// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","rotateBackgrounColor":"app_rotateBackgrounColor__1t1J8"};